import { useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Track() {
  const [num, setNum] = useState("");
  const navigate = useNavigate();

  return (
    <main className="px-5 pt-40 pb-32 max-w-xl mx-auto text-center">
      <p className="font-mono text-[11px] tracking-[0.3em] text-volt mb-4">ORDER TRACKING</p>
      <h1 className="font-display font-extrabold uppercase tracking-tighter text-3xl sm:text-4xl">WHERE'S MY UNIT?</h1>
      <form
        className="mt-10 flex gap-3"
        onSubmit={(e) => { e.preventDefault(); if (num.trim()) navigate(`/order/${num.trim().toUpperCase()}`); }}
      >
        <input
          data-testid="track-order-input"
          value={num}
          onChange={(e) => setNum(e.target.value.toUpperCase())}
          placeholder="RVXXXXXXXXXX"
          className="flex-1 bg-[#151821] border border-white/15 px-4 py-4 font-mono text-sm tracking-widest text-ink placeholder:text-mute focus:outline-none focus:border-acid"
        />
        <button data-testid="track-submit-btn" type="submit" className="bg-volt text-void font-display font-bold text-sm tracking-widest px-8 hover:bg-acid transition-colors">
          TRACK
        </button>
      </form>
      <p className="mt-6 font-mono text-[10px] tracking-widest text-mute">ENTER THE ORDER NUMBER FROM YOUR CONFIRMATION PAGE</p>
    </main>
  );
}
